/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankDtoApiResponse } from '../../models/bank-dto-api-response';
import { CreateCustomerBankCommand } from '../../models/create-customer-bank-command';

export interface CreateBankAsync$Params {
  id: number;
      body?: CreateCustomerBankCommand
}

export function createBankAsync(http: HttpClient, rootUrl: string, params: CreateBankAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<BankDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createBankAsync.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BankDtoApiResponse>;
    })
  );
}

createBankAsync.PATH = '/api/customer/{id}/bank';
